import { useLocation, useNavigate } from 'react-router-dom';
import { useNavigationHistory } from './useNavigationHistory';

export const useGoBack = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const history = useNavigationHistory();

  const goBack = ({ fallBack, goBackSteps = 1 }: { fallBack: string; goBackSteps?: number }) => {
    const thereIsAPrevPage = location.key !== 'default';
    const nonReplaceHistory = history.filter((entry) => !entry.isReplace);

    if (thereIsAPrevPage && nonReplaceHistory.length > goBackSteps) {
      navigate(-goBackSteps);
    } else {
      navigate(fallBack || '/');
    }
  };

  return goBack;
};
